module.exports = __webpack_public_path__ + "img/40200.a2fa494c.jpg";